import SettingsIcon from "./SettingsIcon.mjs";

/** @type {GlyphIcon} */
export default SettingsIcon;
